import { useRecoilValue } from "recoil";
import {
  updateTimer,
  updateTimerTime,
} from "../../../../../api/tournament-timer";
import { useControllerContext } from "../../../hooks/controller-context";
import { pubState } from "../../../../../recoil/pub.atom";
import { isTournamentAccess } from "../../../../../utils/owner";

export const useTournamentTimer = () => {
  const { data, timeInfo, getData } = useControllerContext();
  const now_level_time_radius = 190;
  const circumference = 2 * Math.PI * now_level_time_radius;
  const pub = useRecoilValue(pubState);

  const calculateStrokeDashoffset = () => {
    if (
      timeInfo.currentLevel &&
      timeInfo.elapsedTimeInCurrentLevelMs &&
      timeInfo.elapsedTimeMs &&
      timeInfo.elapsedTimeMs > 0
    ) {
      const progress =
        timeInfo.elapsedTimeInCurrentLevelMs /
        (timeInfo.currentLevel.time * 60000);
      return circumference * (1 - progress);
    }
    return circumference;
  };

  const handleCircleClick = async (e: React.MouseEvent<SVGCircleElement>) => {
    if (
      !timeInfo.currentLevel ||
      !timeInfo.elapsedTimeInCurrentLevelMs ||
      !data?.timerDto ||
      !timeInfo.elapsedTimeMs ||
      timeInfo.elapsedTimeMs < 0
    )
      return;

    if (!isTournamentAccess(data.id, pub?.tournamentIds)) {
      alert(`토너먼트 ID ${data.id}에 대한 권한이 없습니다. `);
      return;
    }

    const svg = e.currentTarget;
    const rect = svg.getBoundingClientRect();
    const clickX = e.clientX - rect.left;
    const clickY = e.clientY - rect.top;

    const centerX = now_level_time_radius;
    const centerY = now_level_time_radius;

    const dx = clickX - centerX;
    const dy = clickY - centerY;

    let clickAngle = Math.atan2(dy, dx) * (180 / Math.PI) + 90;
    if (clickAngle < 0) clickAngle += 360;

    const newProgress = Math.min(Math.max(clickAngle / 360, 0), 1);

    const clickedMs = newProgress * timeInfo.currentLevel.time * 60000;
    const msDifference = clickedMs - timeInfo.elapsedTimeInCurrentLevelMs;
    const type = `${msDifference > 0 ? "+" : ""}${(msDifference / 1000).toFixed(
      0,
    )}초`;
    try {
      await updateTimer(
        data?.timerDto?.id,
        timeInfo.elapsedTimeMs + +msDifference.toFixed(0) >= 0
          ? timeInfo.elapsedTimeMs + +msDifference.toFixed(0)
          : 0,
        undefined,
        type,
      );
      getData();
      setTimeout(() => {}, 500);
    } catch (e: any) {
      if (e.status === 403) {
        alert(e.response.data.message);
      }
    }
  };

  const handleUpdateTime = async (value: number, isStop?: boolean) => {
    if (
      !data?.timerDto ||
      timeInfo.elapsedTimeMs === undefined ||
      timeInfo.elapsedTimeMs === null ||
      timeInfo.elapsedTimeMs < 0
    )
      return;
    if (!isTournamentAccess(data.id, pub?.tournamentIds)) {
      alert(`토너먼트 ID ${data.id}에 대한 권한이 없습니다. `);
      return;
    }
    let type;
    if (isStop !== undefined) {
      type = isStop ? "일시정지" : "재개";
    } else {
      type = `${value > 0 ? "+" : ""}${value / 1000}초`;
    }
    try {
      await updateTimerTime(
        data?.timerDto?.id,
        timeInfo.elapsedTimeMs + value >= 0 ? value : -timeInfo.elapsedTimeMs,
        isStop,
        type,
      );
      getData();
    } catch (e: any) {
      if (e.status === 403) {
        alert(e.response.data.message);
        return;
      }
      alert(e.message);
    }
  };

  return {
    now_level_time_radius,
    circumference,
    calculateStrokeDashoffset,
    handleUpdateTime,
    handleCircleClick,
  };
};
